import { Dispatch, SetStateAction } from 'react'

import {
  EmploymentNotification,
  EmploymentType,
} from '@builddocs/data-management'
import { RefetchOptions, RefetchQueryFilters } from 'react-query'

import { FireItem } from './employment/FireItem'
import { HireItem } from './employment/HireItem'

interface OwnProps {
  employment: EmploymentNotification
  setIsUnknown: Dispatch<SetStateAction<boolean>>
  refetch: <TPageData>(
    options?: (RefetchOptions & RefetchQueryFilters<TPageData>) | undefined,
  ) => void
}

export type EmploymentBodyProps = OwnProps

export const EmploymentBody = (props: EmploymentBodyProps) => {
  const { employment, setIsUnknown, refetch } = props

  switch (employment.type) {
    case EmploymentType.HIRE:
      return <HireItem employment={employment} refetch={refetch} />
    case EmploymentType.FIRE:
      return <FireItem employment={employment} />
    default:
      setIsUnknown(true)
      return <></>
  }
}
